module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.zxmaster) ? _c('div', {
    staticClass: "opacity_bg"
  }) : _vm._e(), _vm._v(" "), (_vm.zxmaster) ? _c('div', {
    staticClass: "zx_box"
  }, [_c('div', {
    staticClass: "zx-tit-box"
  }, [_vm._v("\n      大师1V1服务\n      "), _c('img', {
    attrs: {
      "src": require("./_img/icon_tanchuang_close.png")
    },
    on: {
      "click": function($event) {
        return _vm.$emit('hide')
      }
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "zxds_head",
    attrs: {
      "src": _vm.headSrc
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "copy-wx-box"
  }, [_c('img', {
    staticClass: "icon-wx",
    attrs: {
      "src": require("./_img/icon_wechat.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信：" + _vm._s(_vm.wx))]), _vm._v(" "), _c('div', {
    staticClass: "wx-btn",
    attrs: {
      "data-clipboard-text": _vm.wx
    },
    on: {
      "click": _vm.copy_wx
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _c('div', {
    staticClass: "open-wx",
    on: {
      "click": function($event) {
        return _vm.Open_WeChat()
      }
    }
  }, [_vm._v("打开微信")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("添加大师微信，1V1咨询"), _c('span', [_vm._v("（每天限量50名）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53780e28","hasScoped":true}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Consulting_master.vue
// module id = mUM9
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14